var styles = {
  "RangeInput": "pb-RangeInput__RangeInput",
  "rangeInputContainer": "pb-RangeInput__rangeInputContainer",
  "rangeInput": "pb-RangeInput__rangeInput",
  "thumbContainer": "pb-RangeInput__thumbContainer",
  "thumb": "pb-RangeInput__thumb",
  "invalid": "pb-RangeInput__invalid",
  "thumbActive": "pb-RangeInput__thumbActive",
  "fullWidth": "pb-RangeInput__fullWidth",
  "trackProgress": "pb-RangeInput__trackProgress",
  "trackUnfilledProgress": "pb-RangeInput__trackUnfilledProgress",
  "trackLeftClamp": "pb-RangeInput__trackLeftClamp",
  "trackRightClamp": "pb-RangeInput__trackRightClamp",
  "tick": "pb-RangeInput__tick",
  "tickContainer": "pb-RangeInput__tickContainer",
  "trackLabel": "pb-RangeInput__trackLabel",
  "trackLabelText": "pb-RangeInput__trackLabelText",
  "trackLabelContainer": "pb-RangeInput__trackLabelContainer",
  "tickCenter": "pb-RangeInput__tickCenter",
  "progressContainer": "pb-RangeInput__progressContainer",
  "inputContainer": "pb-RangeInput__inputContainer",
  "inputContainer--hasTicks": "pb-RangeInput__inputContainer--hasTicks",
  "tooltip": "pb-RangeInput__tooltip",
  "tooltipTriangle": "pb-RangeInput__tooltipTriangle",
  "tooltipContainer": "pb-RangeInput__tooltipContainer",
  "tooltipSpacerLeft": "pb-RangeInput__tooltipSpacerLeft",
  "tooltipSpacerRight": "pb-RangeInput__tooltipSpacerRight",
  "tooltipTriangleContainer": "pb-RangeInput__tooltipTriangleContainer"
};
export default styles;